import { PageNavigationItem } from '../../../components/Navigation/PageNavigation/PageNavigation';

export const SUB_LINK_IDS = {
  MAP: 'fw-map',
  GENERAL_INFO: 'fw-generalInfo',
  TOP_SPECIES: 'fw-topSpecies',
  FISHING_REPORTS: 'fw-fishingReports',
  FISHING_REGULATIONS: 'fw-regulations',
  SPECIES: 'species',
  TOP_BAITS: 'top-baits',
  LOCAL_GUIDE: 'localGuide',
  REVIEWS: 'fw-reviews',
  NEARBY_WATERS: 'nearby-waters-section',
  SUGGEST_CHANGES: 'suggest-changes-section',
  EXPLORE_MORE: 'explore-more-section',
};

export function getSubNavLinks({
  hasSpecies,
  hasCatches,
  hasGeneralInfo,
  hasReviews,
  hasRegulations,
  hasNearbyWaters,
}: {
  hasSpecies: boolean;
  hasCatches: boolean;
  hasGeneralInfo: boolean;
  hasReviews: boolean;
  hasRegulations: boolean;
  hasNearbyWaters: boolean;
}): PageNavigationItem[] {
  return [
    { id: SUB_LINK_IDS.MAP, label: 'Map' },
    ...(hasSpecies ? [{ id: SUB_LINK_IDS.TOP_SPECIES, label: 'Top species' }] : []),
    ...(hasCatches ? [{ id: SUB_LINK_IDS.FISHING_REPORTS, label: 'Fishing reports' }] : []),
    ...(hasGeneralInfo ? [{ id: SUB_LINK_IDS.GENERAL_INFO, label: 'General info' }] : []),
    ...(hasRegulations ? [{ id: SUB_LINK_IDS.FISHING_REGULATIONS, label: 'Regulations' }] : []),
    ...(hasReviews ? [{ id: SUB_LINK_IDS.REVIEWS, label: 'Reviews' }] : []),
    ...(hasNearbyWaters ? [{ id: SUB_LINK_IDS.NEARBY_WATERS, label: 'Nearby waters' }] : []),
    { id: SUB_LINK_IDS.SUGGEST_CHANGES, label: 'Suggest changes' },
    { id: SUB_LINK_IDS.EXPLORE_MORE, label: 'Explore more' },
  ];
}
